import { observer } from 'mobx-react-lite'
import { AgentActionType, type IAgentActionSettings } from 'entities/AgentActions'

import { useDetailsContext } from '../detailsContext'
import { ActionMessage } from './ActionMessage'
import { ActionTags } from './ActionTags'
import styles from './styles.module.scss'

interface IActionListProps {
  name: string
  actions: IAgentActionSettings[] | null
  customAction?: string
}

export const ActionList = observer(({ name, actions, customAction }: IActionListProps) => {
  const { getFutureActionsTags } = useDetailsContext()

  return (
    <div className={styles.actionCard}>
      <header className={styles.actionCardHead}>{name}</header>
      {!actions?.length && !customAction ? (
        <span className={styles.actionCardsPlaceholder}>Please add actions</span>
      ) : (
        actions?.map((action, index) => {
          switch (action.type) {
            case AgentActionType.AddTag:
              return (
                <ActionTags
                  key={index}
                  name='Add tags'
                  placeholder='Please add tags'
                  futureTags={getFutureActionsTags(action.settings.tag_ids)}
                />
              )
            case AgentActionType.RemoveTag:
              return (
                <ActionTags
                  key={index}
                  name='Remove tags'
                  placeholder='Please add tags'
                  futureTags={getFutureActionsTags(action.settings.tag_ids)}
                />
              )
            case AgentActionType.SendMessage:
              return (
                <ActionMessage
                  key={index}
                  name='Send message'
                  message={action.settings.message}
                  placeholder='Please add message'
                />
              )
            case AgentActionType.ContactNote:
              return (
                <ActionMessage
                  key={index}
                  name='Add contact note'
                  message={action.settings.note}
                  placeholder='Please add note'
                />
              )
            default:
              return null
          }
        })
      )}
      {!!customAction && (
        <ActionMessage name='Path' message={customAction} placeholder='Please add path' />
      )}
    </div>
  )
})
